export default __webpack_public_path__ + "static/media/shield1.bc6bfef2.svg";